module.exports = __webpack_public_path__ + "img/burger-menu.8fe1b3a1.svg";